$(document).ready(() => {
    const csrftoken = $('[name=csrfmiddlewaretoken]').val()
    $('.dropdown-menu [data-toggle="select-lang"]').on('click', function () {
        let lang = $('[data-lang]', this).data('lang');
        if (!lang) return;
        $.ajax({
            url: '/i18n/setlang/',
            type: 'post',
            // Accept без text/html: django ставит куку и отвечает 204. Иначе он редиректит
            // на referer, jquery тянет страницу целиком, а её код (204 или ошибка страницы)
            // проверку на 200 не проходил — язык менялся, но страница не обновлялась.
            headers: {Accept: 'application/json'},
            data: {csrfmiddlewaretoken: csrftoken, language: lang}
        }).done(function () {
            location.reload();
        });

    })

});


export function copyToClipboard(elem, root = null) {
    let text, succeed;

    let $temp = $("<input>");
    if (root) {
        $(root).append($temp);
    } else {
        $('body').append($temp);
    }


    if (elem instanceof $) {
        text = $(elem).val();
    } else if (typeof (elem) === 'string') {
        text = elem;
    } else {
        text = Object.keys(elem).map(key => `${key}:${elem[key]} `).join('\n');
    }

    $temp.val(text).focus().select();
    try {
        succeed = document.execCommand('copy');
    } catch (e) {
        console.warn(e);
        succeed = false;
    }
    $temp.remove();

    return succeed;
}

export function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

// -------------- DATATABLE ---------------------


export function splitGroupBySearch(str) {
    return str.split(':')

}

export function getValueByGroup(parent, select = null) {
    let filters = select ? parent.find(`[data-target-group="${select}"]`) : parent.find(`[data-target-group]`)
    return filters.filter('input').val() ? filters.map((i, elem) => $(elem).val()).toArray().join(':') : ''; // пустое если инпут не заполнен
}

export function onChangeFilter(dtApi) {
    let filed = $(this);
    let th = filed.closest('th'); //порядковый номер в наборе
    let colIdx = th.index(); //порядковый номер в наборе
    let val;
    if (filed.attr('data-target-group')) {
        val = getValueByGroup(th, filed.data('targetGroup'));
    } else {
        val = filed.val().trim();
    }
    if (dtApi.column(colIdx).search() !== val) {
        dtApi.column(colIdx).search(val, false, true, true);
        dtApi.draw();
    }
}

// -------------- DATATABLE ---------------------

export const Toast = {
    showError: (header, responseJSON) => {
        $.toast({
            heading: 'Error',
            text: `<strong>${header}</strong>
                        <p>${responseJSON?.replace(/\n/g, '<br>')}</p>`,
            bgColor: 'red',
            icon: 'error',
            position: 'mid-center',
            hideAfter: 5000,
        });
    }
}